import {postApi} from "@/utils/callApi";
import Swal from "sweetalert2";
export function popUp (){
    let url = "external/v1/billBoard/announcement";
    let domain = "https://azt-frontend.tmnewa.com.tw/ecapi/common/";
    if(process.env.VUE_APP_ENV === 'prod'){
        domain = "https://b2capi-gateway.tmnewa.com.tw/ecjapi/common/";
    }

    let data = {
        "sysId": location.host,
        "pageId": location.pathname + location.hash
    }

    postApi(domain + url, null, null, null, data)
        .then(response=>{
            const announcementRes = response.data;
            if(announcementRes.code === 200){
                Swal.fire({
                    title: announcementRes.data.title,
                    showConfirmButton: true,
                    showCloseButton: true,
                    html: '<img src="noticemark.svg"><p>'+ announcementRes.data.description + '</p>',
                }).then(function () {
                    if(announcementRes.data.isRedirect === 'Y'){
                        window.location = announcementRes.data.redirectUrl;
                    }
                });
            }
        });
}